const PaymentStatusStrings = {
    NEW: 'new',
    CHECKOUT_INCOMPLETE: 'checkout_incomplete',
    CHECKOUT_AUTHORIZED: 'checkout_authorized',
    CHECKOUT_COMPLETE: 'checkout_complete',
    CHECKOUT_STARTED: 'checkout_started',
};
const PdfGenerateStatusStrings = {
    PENDING: 'PENDING',
};
const ReconciliationDescription = {
    ITEM_WAS_CANCELED: 'Item was canceled',
};

export { PaymentStatusStrings, PdfGenerateStatusStrings, ReconciliationDescription };
//# sourceMappingURL=constants.js.map
